import { render } from "./documents_editor_crop.vue?vue&type=template&id=77fa294e"
import script from "./documents_editor_crop.vue?vue&type=script&lang=js"
export * from "./documents_editor_crop.vue?vue&type=script&lang=js"

import exportComponent from "/app/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__